import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Play } from "lucide-react";

export default function HeroSection() {
  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 text-red-600 rounded-full text-base font-medium mb-8">
            <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
            Nền tảng mô phỏng giao diện kỳ thi HSK
          </div>

          {/* Headline */}
          <h1 className="whitespace-nowrap text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Thi thử HSK hoàn toàn miễn phí
            <br />
            <span className="text-red-600">với 86HSK</span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Làm quen với thao tác thi trên máy, tự tin chinh phục kỳ thi thật. 
            <br />Gia nhập cộng đồng luyện thi tiếng Trung cùng 86 HSK.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Link
              to="/register"
              className="w-full sm:w-auto group inline-flex items-center justify-center gap-2 px-8 py-4 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <span>Bắt đầu miễn phí</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href="https://tiengtrung86hsk.com/lien-he/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-gray-900 font-semibold rounded-xl hover:bg-gray-50 transition-colors border-2 border-gray-200 cursor-pointer"
            >
              <Play className="w-5 h-5" />
              <span>Khám phá khóa học</span>
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-8 border-t border-gray-100">
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-1">10,000+</div>
              <div className="text-sm text-gray-600">Học viên</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-1">100+</div>
              <div className="text-sm text-gray-600">Học liệu & đề thi miễn phí</div>
            </div>
            <div>
              <div className="text-3xl sm:text-4xl font-bold text-gray-900 mb-1">200+</div>
              <div className="text-sm text-gray-600">Học viên thi đỗ HSK3 & HSK4</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
